


















































































































































































































































































import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import {DeliveryCompany} from 'supporter';
import deliveryTypes from '@/const/words/deliveryTypes';
import deliveryConditionTypes from '@/const/words/deliveryConditionTypes';
import {ncpPopup} from '@/utils/ncp';
import {State} from 'vuex-class';
import store from '@/store';
import PeriodDateCalendar from '@/components/common/datepicker/PeriodDateCalendar.vue';
window.addEventListener(
  'message',
  function (event: any) {
    if (event.data.templateNo) {
      store.commit('delivery/SET_DELIVERY_TEMPLATE_NO', event.data.templateNo);
    }
  },
  false
);
@Component({
  components: {PeriodDateCalendar}
})
export default class DeliveryInformation extends Vue {
  private event: any = null;
  private deliveryTypes = deliveryTypes;
  @Prop({required: true}) immutableFields!: string[];
  private stateDeliveryConditionTypes = deliveryConditionTypes;
  @Prop({required: true}) private deliveryCompanyTypes!: DeliveryCompany[];
  @Prop({required: true}) private product!: any;
  @Prop({required: true}) private deliveryDate!: any;
  @Prop({required: true}) private error!: any;
  @Prop({required: true}) private isMapping!: any;

  @Prop({required: true}) private deliveryTemplates!: any;
  @Prop({required: true}) private deliveryCustomerInfo!: any;
  @State('deliveryTemplateNo', {namespace: 'delivery'})
  private stateDeliveryTemplateNo!: number;
  private returnAmtGuidePopup = false;
  private isDeliveryTemplateToolTip = false;
  private selectedDeliveryTemplate: any = {
    deliveryType: '',
    deliveryCompanyType: '',
    deliveryFee: {
      deliveryConditionType: '',
      deliveryAmt: '',
      returnDeliveryAmt: ''
    },
    releaseWarehouse: {
      substitutionText: '',
      address: {
        addressStr: ''
      }
    },
    returnWarehouse: {
      substitutionText: '',
      address: {
        addressStr: ''
      }
    }
  };
  @Watch('stateDeliveryTemplateNo')
  onStateDeliveryTemplateNoChanged(newVal: number) {
    if (newVal) {
      this.setNewDeliveryTemplateNo(newVal);
    }
  }
  @Watch('deliveryTemplates')
  onDeliveryTemplatesChanged() {
    if (this.deliveryTemplates.length) {
      const currentTemplate = this.deliveryTemplates.find((item: any) => item.templateNo === this.product.deliveryTemplateNo);
      const defaultTemplate = this.deliveryTemplates.find((item: any) => item.default);
      if (currentTemplate) {
        this.selectedDeliveryTemplate = currentTemplate;
      } else if (defaultTemplate) {
        // * default 배송템플릿으로 설정.
        this.selectedDeliveryTemplate = defaultTemplate;
      } else {
        this.selectedDeliveryTemplate = this.deliveryTemplates[0];
      }

      this.product.deliveryTemplateNo = this.selectedDeliveryTemplate.templateNo;
    } else {
      this.product.deliveryTemplateNo = 0;
    }
  }

  @Watch('product.classType')
  onClassTypeChanged() {
    if (this.isRentalType) {
      this.product.deliveryCombinationYn = true;
    }
  }

  @Watch('product.deliveryTemplateNo')
  onDeliveryTemplateNoChanged() {
    if (!this.product.deliveryTemplateNo) {
      this.selectedDeliveryTemplate = {
        deliveryType: '',
        deliveryCompanyType: '',
        deliveryFee: {
          deliveryConditionType: '',
          deliveryAmt: '',
          returnDeliveryAmt: ''
        },
        releaseWarehouse: {
          name: ''
        },
        returnWarehouse: {
          name: ''
        }
      };
    }else{
      this.selectedDeliveryTemplate = this.deliveryTemplates.find((item: any) => item.templateNo === this.product.deliveryTemplateNo);
    }
  }
  private get isRentalType() {
    return this.product.classType === 'RENTAL';
  }
  get deliveryDaysOfWeekALL(){
    return this.product.deliveryDueDate.daysOfTheWeek.length === 5
  }
  set deliveryDaysOfWeekALL(value){
    if(value){
      this.product.deliveryDueDate.daysOfTheWeek = ['MON','TUE','WED','THU','FRI']
    }else{
      this.product.deliveryDueDate.daysOfTheWeek = []
    }
  }
  getDeliveryType(value: string): string {
    if (value) {
      const finded = this.deliveryTypes.find((item: any) => item.value === value);
      return finded ? finded.name : '';
    }
    return '';
  }
  getDeliveryCompany(value: string): string {
    if (value) {
      const finded = this.deliveryCompanyTypes.find((item) => item.deliveryCompanyType === value);
      return finded ? (finded as DeliveryCompany).label : '';
    }
    return '';
  }
  getDeliveryConditionType(value: string): string {
    if (value) {
      const finded = this.stateDeliveryConditionTypes.find((item: any) => item.value === value);
      return finded ? finded.name : '';
    }
    return '';
  }
  addTemplate() {
    if (!this.product.partnerNo) {
      alert(this.$t('PRODUCT_ADD_REQUIRE_PARTNER'));
    }
    if (!this.product.mallNo) {
      alert(this.$t('PRODUCT_ADD_REQUIRE_MALL_NO'));
      $('#mallNo').focus();
      return;
    } else if (!this.product.partnerNo) {
      $('#partnerNo').focus();
      return;
    }
    ncpPopup(`/deliveryTemplate/addForm?partnerNo=${this.product.shippingAreaType === 'PARTNER_SHIPPING_AREA' ? this.product.partnerNo:this.product.shippingAreaPartnerNo}`, this.$t('PRODUCT_ADD_DELIVERY_TEMPLATE_POP_TITLE'));
  }
  setNewDeliveryTemplateNo(deliveryTemplateNo: number) {
    this.$emit('getPartnerDeliveryTemplates', this.product.partnerNo);
    this.product.deliveryTemplateNo = deliveryTemplateNo;
  }
  changedDeliveryYn() {
    if (this.isMapping && this.product.deliveryYn === 'N') {
      alert(this.$t('PRODUCT_ADD_REQUIRE_DELIVERY'));
      this.product.deliveryYn = 'Y';
    }
  }
  private periodOption = {
    dateType: 'Ymd',
    havePeriodBtn: false,
    name: 'period'
  };
}
